 let actions = {
     createNewRebate({ commit }, rebate) {
         axios.post('/rebate', rebate, { headers: { 'Content-Type': 'multipart/form-data' } })
             .then(res => {
                 commit('CREATE_CUSTOMER', res.data.customer)
                 commit('CREATE_REBATE', res.data.rebate)
                 commit('CREATE_MVPD_INFO', res.data.mvpdinfo)
                 commit('CHECK_REBATE', res.data)
                 commit('SHOW_ERRORS', {})
             }).catch(err => {
                 if (err.response.status == 422) {
                     console.log(err.response)
                     commit('SHOW_ERRORS', err.response.data.errors)
                 }
             })

     },
     editExistingRebate({ commit }, payload) {
         axios.post(`/rebate/${payload.confirmation}`, payload.rebate, { headers: { 'Content-Type': 'multipart/form-data' } })
             .then(res => {
                 commit('CREATE_CUSTOMER', res.data.customer)
                 commit('CREATE_REBATE', res.data.rebate)
                 commit('CREATE_MVPD_INFO', res.data.mvpdinfo)
                 commit('CHECK_REBATE', res.data)
                 commit('SHOW_ERRORS', {})
             }).catch(err => {
                 if (err.response.status == 422) {
                     console.log(err.response)
                     commit('SHOW_ERRORS', err.response.data.errors)
                 }
             })

     },
     checkRebate({ commit }, rebate) {
         axios.get(`/rebate/check/${rebate.confirmation}`)
             .then(res => {
                 if (Object.keys(res.data).length === 0) {
                     commit('SHOW_ERRORS', { 'email': ['Sorry we didn\'t find a rebate matching that.  Try again.'] })
                 } else {
                     commit('CHECK_REBATE', res.data)
                     this.setBillsRequred(res.data.mvpd_info.mvpd)
                 }
             }).catch(err => {
                 console.log(err)
             })
     },
     setBillsRequired({ commit }, val) {
         switch (val) {
             case 'REV (EATEL Westside)':
             case 'REV (EATEL)':
             case 'REV (Reserve Telecommunications)':
             case 'REV (Vision Communications)':
             case 'NDTC (North Dakota Telephone Company)':
             case 'Antietam Cable Television':
             case 'Armstrong':
             case 'Comporium':
             case 'EPB Fiber Optics':
             case 'Fidelity Communications':
             case 'GVTC Communications':
             case 'Hargray':
             case 'HBC':
             case 'HTC Digital Cable':
             case 'Long Lines':
             case 'Mediacom':
             case 'MetroNet':
             case 'Orbitel Communications':
             case 'Service Electric Cable TV Hunterdon':
             case 'Service Electric Cable TV Lehigh Valley':
             case 'Service Electric Cable TV Wilkes Barre':
             case 'Shentel':
             case 'Skitter TV':
             case 'Sparklight':
             case 'WesTel Systems':
             case 'Ziply Fiber':
                 commit('SET_BILLSREQUIRED', 6)
                 break;
             default:
                 commit('SET_BILLSREQUIRED', 3)
         }
     }
 }

 export default actions